export type ProviderName = 'bitmex' | 'binance' | 'kraken' | 'twelvedata' | 'alphavantage' | 'oanda';
export type MarketStatus = 'open' | 'closed';
export type SessionState =
  | 'always_open'
  | 'regular_session'
  | 'early_close_session'
  | 'weekend_closure'
  | 'holiday_closure'
  | 'pre_market'
  | 'post_market';

export function isProviderName(value: unknown): value is ProviderName {
  return (
    value === 'bitmex' ||
    value === 'binance' ||
    value === 'kraken' ||
    value === 'twelvedata' ||
    value === 'alphavantage' ||
    value === 'oanda'
  );
}

export function symbolSupportsLiveStream(provider: ProviderName): boolean {
  return provider === 'bitmex' || provider === 'binance' || provider === 'kraken' || provider === 'oanda';
}

export function getProviderDisplayName(provider: ProviderName): string {
  if (provider === 'bitmex') {
    return 'BitMEX';
  }
  if (provider === 'binance') {
    return 'Binance';
  }
  if (provider === 'kraken') {
    return 'Kraken';
  }
  if (provider === 'alphavantage') {
    return 'Alpha Vantage';
  }
  if (provider === 'oanda') {
    return 'OANDA';
  }
  return 'Twelve Data';
}
